'use client';

function imageLoader(_a) {
    var src = _a.src, width = _a.width, quality = _a.quality;
    // SVG is not supported by next/image
    var extension = src === null || src === void 0 ? void 0 : src.substring(src.length - 4);
    if (extension.indexOf('.svg') === 0) {
        return src;
    }
    return "".concat(process.env.NEXT_PUBLIC_IMAGE_LOADER, "?url=").concat(encodeURIComponent(src), "&w=").concat(width, "&q=").concat(quality || 75);
}

export { imageLoader };
//# sourceMappingURL=image.js.map
